module.exports = __webpack_public_path__ + "31220459588f9cfccf24897ccd4156fe.svg";